import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import InternalHeader from '../../components/global/InternalHeader';
import Page from '../../components/global/Page';
import { changePassword } from '../../libs/apis';

function UpdatePassword() {
  const { t } = useTranslation();
  const history = useHistory();

  const initialState = {
    password: '',
    newPassword: '',
    verifyPassword: '',
    loading: false,
    success: false,
    error: false,
    message: '',
    passwordAlert: false,
    samePassword: false,
    isEmpty: true,
  };
  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };
  const {
    password,
    newPassword,
    verifyPassword,
    loading,
    success,
    error,
    message,
    passwordAlert,
    samePassword,
    isEmpty,
  } = state;

  const handleSubmit = async ev => {
    ev.preventDefault();
    setState({ loading: true, error: false, message: '', success: false });
    if (
      password.length > 7 &&
      newPassword.length > 7 &&
      !samePassword &&
      !passwordAlert
    ) {
      const payload = {
        old_password: password,
        password: newPassword,
        password_confirmation: verifyPassword,
      };
      await changePassword(payload)
        .then(resp => {
          if (resp.status === 200) {
            setState({
              success: true,
              password: '',
              newPassword: '',
              verifyPassword: '',
            });
            setTimeout(() => {
              history.push('/profile');
            }, 2000);
          } else {
            setState({
              error: true,
              message: resp.data.error.message,
              success: false,
            });
          }
        })
        .catch(err => console.log('err', err))
        .finally(() => setState({ loading: false }));
    }
  };
  useEffect(() => {
    if (password === '' || newPassword === '' || verifyPassword === '') {
      setState({ isEmpty: true });
    } else {
      setState({ isEmpty: false });
    }
  }, [password, newPassword, verifyPassword]);

  return (
    <div className="app-container">
      <InternalHeader title={t('change_password_page')} />
      <div className="main-content pb-5">
        <Page>
          <div className="content py-3 text-break">
            {error && (
              <div className="alert text-center alert-danger" role="alert">
                {message}
              </div>
            )}
            {success && (
              <div className="alert text-center alert-success" role="alert">
                {t('change_password_success_text')}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-floating mb-3">
                <input
                  className="form-control"
                  type="password"
                  id="password"
                  value={password}
                  minLength="8"
                  maxLength="25"
                  onChange={e => {
                    setState({ password: e.target.value });
                  }}
                  disabled={loading}
                  required
                  placeholder={t('old_password_label')}
                />
                <label htmlFor="password">{t('old_password_label')}</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  className={`form-control ${samePassword ? 'is-invalid' : ''}`}
                  type="password"
                  minLength="8"
                  maxLength="25"
                  id="newPassword"
                  value={newPassword}
                  onChange={e => {
                    setState({ newPassword: e.target.value });
                    if (e.target.value === password) {
                      setState({ samePassword: true });
                    } else {
                      setState({ samePassword: false });
                    }
                    if (
                      e.target.value !== verifyPassword &&
                      verifyPassword !== ''
                    ) {
                      setState({ passwordAlert: true });
                    } else {
                      setState({ passwordAlert: false });
                    }
                  }}
                  disabled={loading}
                  required
                  placeholder={t('new_password_label')}
                />
                <label htmlFor="newPassword">{t('new_password_label')}</label>
                {samePassword && (
                  <div className="invalid-feedback">
                    {t('same_password_alert')}
                  </div>
                )}
              </div>

              <div className="form-floating mb-3">
                <input
                  className={`form-control ${
                    passwordAlert ? 'is-invalid' : ''
                  }`}
                  type="password"
                  id="verifyPassword"
                  minLength="8"
                  maxLength="25"
                  required
                  value={verifyPassword}
                  onChange={e => {
                    setState({ verifyPassword: e.target.value });
                    if (e.target.value === newPassword) {
                      setState({ passwordAlert: false });
                    } else {
                      setState({ passwordAlert: true });
                    }
                  }}
                  disabled={loading}
                  placeholder={t('verify_password_label')}
                />
                <label htmlFor="verifyPassword">
                  {t('verify_password_label')}
                </label>
                {passwordAlert && (
                  <div className="invalid-feedback">
                    {t('verify_password_alert')}
                  </div>
                )}
              </div>
              {isEmpty || passwordAlert || samePassword ? (
                <button
                  type="button"
                  className="btn bg-gradient btn-lg btn-secondary w-100"
                  disabled
                >
                  {t('change_password_button')}{' '}
                  <span className="ms-2 fa fa-save"></span>
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn bg-gradient btn-lg btn-success w-100"
                >
                  {t('change_password_button')}{' '}
                  <span className="ms-2 fa fa-save"></span>
                </button>
              )}
            </form>
          </div>
        </Page>
      </div>
    </div>
  );
}

export default UpdatePassword;
